const dashboard = {
  departments: "autopilot",
  employees: "users",
  device: "devices",
  application: "applications",
  create_dep: "Create Autopilot",
  create_dep_desc: "Create Autopilot for easier management",
  basic_title: "Security Essentials",
  disc_encrypt: "Disk encryption <br /> coverage",
  firewall: "Firewall <br /> coverage",
};
export default {
  dashboard,
};
